var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#GradientFill_3-2);\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#GradientFill_3);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3",
    "data-name": "GradientFill 3",
    x1: 25,
    y1: 50,
    x2: 25,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa780c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#d1b24a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5d06a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-2",
    "data-name": "GradientFill 3",
    x1: 24.78,
    y1: 50.01,
    x2: 24.78,
    y2: 0.01,
    xlinkHref: "#GradientFill_3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25,3.06C12.9,3.06,3.06,12.9,3.06,25s9.84,21.94,21.94,21.94,21.94-9.84,21.94-21.94S37.1,3.06,25,3.06M25,50C11.22,50,0,38.79,0,25S11.22,0,25,0s25,11.21,25,25-11.22,25-25,25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.78,40.27c-2.12,0-4.12-.41-6.01-1.22s-3.53-1.92-4.94-3.33-2.52-3.05-3.33-4.94-1.22-3.89-1.22-6.01.41-4.15,1.22-6.03,1.92-3.51,3.33-4.92,3.05-2.52,4.94-3.33c1.89-.81,3.89-1.22,6.01-1.22s4.15.41,6.03,1.22c1.87.81,3.51,1.92,4.92,3.33s2.52,3.05,3.33,4.92c.81,1.87,1.22,3.88,1.22,6.03s-.41,4.12-1.22,6.01-1.92,3.53-3.33,4.94-3.05,2.52-4.92,3.33-3.88,1.22-6.03,1.22ZM24.78,30.97c1.55,0,3.06.23,4.53.68s2.85,1.1,4.15,1.96c1.19-1.19,2.11-2.54,2.75-4.05s.97-3.11.97-4.79c0-3.46-1.2-6.39-3.6-8.8-2.4-2.4-5.33-3.6-8.8-3.6s-6.39,1.2-8.8,3.6-3.6,5.33-3.6,8.8c0,1.68.32,3.28.95,4.8s1.56,2.87,2.77,4.03c1.29-.85,2.67-1.5,4.15-1.96s2.98-.68,4.53-.68ZM24.78,34.07c-1.06,0-2.09.13-3.1.39-1.01.26-1.96.65-2.87,1.16.9.52,1.86.9,2.87,1.16s2.04.39,3.1.39,2.09-.13,3.1-.39,1.96-.65,2.87-1.16c-.9-.52-1.86-.9-2.87-1.16-1.01-.26-2.04-.39-3.1-.39ZM17.03,23.22c.44,0,.81-.15,1.1-.45s.45-.67.45-1.1-.15-.81-.45-1.1-.67-.45-1.1-.45-.81.15-1.1.45c-.3.3-.45.67-.45,1.1s.15.81.45,1.1c.3.3.67.45,1.1.45ZM21.68,18.57c.44,0,.81-.15,1.1-.45s.45-.67.45-1.1-.15-.81-.45-1.1-.67-.45-1.1-.45-.81.15-1.1.45-.45.67-.45,1.1.15.81.45,1.1.67.45,1.1.45ZM32.53,23.22c.44,0,.81-.15,1.1-.45s.45-.67.45-1.1-.15-.81-.45-1.1-.67-.45-1.1-.45-.81.15-1.1.45-.45.67-.45,1.1.15.81.45,1.1.67.45,1.1.45ZM24.78,27.87c.85,0,1.58-.3,2.19-.91s.91-1.34.91-2.19c0-.34-.05-.67-.15-.99-.1-.32-.26-.61-.46-.87l2.09-5.27c.18-.41.19-.82.02-1.22s-.46-.69-.87-.87c-.39-.18-.78-.19-1.18-.02s-.68.46-.83.87l-2.09,5.27c-.77.13-1.42.48-1.94,1.07s-.77,1.26-.77,2.03c0,.85.3,1.58.91,2.19s1.34.91,2.19.91Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCca);
export default __webpack_public_path__ + "static/media/Icon_CCA.2b106153322aaff3af59d3a0f0e4562c.svg";
export { ForwardRef as ReactComponent };